// Feature Flags Configuration
// Set these flags to true/false to enable/disable features
// Admins will always see all features regardless of flag settings

export const FEATURE_FLAGS = {
  // Virtual Portfolio Feature
  FEATURE_FLAG_VIRTUAL_PORTFOLIO: false,
  
  // Add more feature flags here as needed
  // FEATURE_FLAG_EXAMPLE: true,
};

// Helper function to check if a feature is enabled
// Admins will always have access to all features
export const isFeatureEnabled = (featureFlag, isAdmin = false) => {
  if (isAdmin) {
    return true; // Admins always see all features
  }
  return FEATURE_FLAGS[featureFlag] || false;
};

// Individual feature flag getters for convenience
export const isVirtualPortfolioEnabled = (isAdmin = false) => 
  isFeatureEnabled('FEATURE_FLAG_VIRTUAL_PORTFOLIO', isAdmin);
